/**
 * @deprecated DEPRECATED AS OF 2025-01-09
 * 
 * Styles for ZappierConnectModal component (no longer used).
 * See ZappierConnectModal.tsx for deprecation details.
 * 
 * **Scheduled for removal:** 2025-04-09 (3 months)
 */

import styled from "styled-components";
interface ResponsiveProps {
  $isPhone?: boolean;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
  $loading?: boolean;
}
export const StyledModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalBox = styled.div<ResponsiveProps>`
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  width: ${({ $isPhone }) => ($isPhone ? "95%" : "900px")};
  max-width: 95vw;
  max-height: 95vh;
  text-align: center;
  direction: rtl;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ActionContainer = styled.div<ResponsiveProps>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "flex-end")};
  height: ${({ $isPhone }) => ($isPhone ? "70px" : "80px")};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  background: white;
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "32px")};
  flex-shrink: 0;
`;

export const StyledButton = styled.button<ResponsiveProps>`
  width: ${({ $width }) => $width || "auto"};
  height: 49px;
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: ${({ $TextColor }) => $TextColor};
  background-color: ${({ $BgColor }) => $BgColor};
  border: 1px solid #5b3fff;
  cursor: pointer;
  padding: 0 24px;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ $BgColor }) => $BgColor};
    color: ${({ $TextColor }) => $TextColor};
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(91, 63, 255, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const CloseButtonContainer = styled.div<ResponsiveProps>`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 60px;
  cursor: ${({ $loading }) => ($loading ? "not-allowed" : "pointer")};
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
  flex-shrink: 0;
  opacity: ${({ $loading }) => ($loading ? 0.5 : 1)};
  transition: opacity 0.2s ease;
`;

export const ContentWrapper = styled.div<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex: 1;
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "16px")};
  overflow-y: auto;
  min-height: 0;
`;

export const InstructionsText = styled.p<ResponsiveProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "22px")};
  font-weight: 400;
  color: #625783;
  margin: 0 0 20px 0;
  line-height: 1.5;
  text-align: center;
  max-width: ${({ $isPhone }) => ($isPhone ? "100%" : "600px")};
  padding: 0 16px;
`;

export const IframeContainer = styled.div<ResponsiveProps>`
  width: 100%;
  max-width: ${({ $isPhone }) => ($isPhone ? "100%" : "700px")};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background: #f8f9fa;

  iframe {
    border: 0;
    width: 100%;
    min-height: ${({ $isPhone }) => ($isPhone ? "450px" : "550px")};
    border-radius: 12px;
    background: white;
  }
`;

export const IconContainer = styled.span<ResponsiveProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: ${({ $isPhone }) => ($isPhone ? "6px" : "16px")};
  min-height: ${({ $isPhone }) => ($isPhone ? "35px" : "70px")};

  @media (max-width: 480px) {
    padding: 4px;
    min-height: 32px;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    padding: 6px;
    min-height: 35px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    padding: 14px;
    min-height: 65px;
  }

  @media (min-width: 1025px) {
    padding: 16px;
    min-height: 70px;
  }
`;

export const IconWrapper = styled.div<ResponsiveProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  max-width: ${({ $isPhone }) => ($isPhone ? "140px" : "280px")};
  gap: ${({ $isPhone }) => ($isPhone ? "6px" : "16px")};
  flex-wrap: ${({ $isPhone }) => ($isPhone ? "wrap" : "nowrap")};
  justify-content: center;

  @media (max-width: 768px) {
    gap: 4px;
    max-width: 100%;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    gap: 14px;
    max-width: 250px;
  }

  @media (min-width: 1025px) {
    gap: 16px;
    max-width: 280px;
  }
`;
